module.exports = __webpack_public_path__ + "media/apartment_blank.e29ec120.svg";